import { layout } from 'thewest/App.routing'

import { createPageDefinition } from 'common/routing/page-definition'
import { TheWestSection } from 'component-library/__styling/settings/sections/thewest'
import { isFeatureEnabled } from 'common/feature-togglings/features'
import { metrics } from 'component-library/__styling/settings'
import { Store } from 'redux'

export function createCookieSettingsPage(store: Store, section: TheWestSection = 'default') {
    if (!isFeatureEnabled(store.getState().toggles, 'cookie-consent')) {
        return null
    }

    return createPageDefinition(
        {
            heading: 'Cookie Settings',
            hideHeading: true,
            pageType: 'static',
            adTargeting: {
                pageId: 'cookie-settings',
                adUnitPath: '',
                ssAdUnits: [],
                topics: [],
            },
            section,
        },
        layout.composition({
            type: 'box',
            props: {
                containerWidth: metrics.thewest.mainContentWidth,
                verticalGutters: ['outerMargin', 'unset'],
                horizontalGutters: 'outerMargin',
            },
            contentAreas: {
                main: [
                    layout.component({
                        type: 'breadcrumb',
                        props: {
                            title: 'Cookie Settings',
                            enableHeaderTag: true,
                        },
                    }),
                ],
            },
        }),
        layout.composition({
            type: 'thor',
            props: {
                containerWidth: metrics.thewest.mainContentWidth,
                verticalGutters: true,
                horizontalGutters: false,
            },
            contentAreas: {
                main: [
                    layout.nestedComposition({
                        type: 'thor',
                        props: {
                            containerWidth: '100%',
                            horizontalGutters: true,
                            hasBackgroundFill: true,
                        },
                        contentAreas: {
                            main: [
                                layout.component({
                                    type: 'cookie-consent-user-settings-page',
                                    props: {},
                                }),
                            ],
                        },
                    }),
                ],
            },
        })
    )
}
